import { Icon, IconProps } from "@chakra-ui/icon";

const CakeIcon = (props: IconProps) => {
  return (
    <Icon
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.04147 7.95007H12.9581C12.9581 7.95007 13.9498 7.95007 13.9498 8.94174V13.239C13.9498 13.239 13.9498 14.2306 12.9581 14.2306H3.04147C3.04147 14.2306 2.0498 14.2306 2.0498 13.239V8.94174C2.0498 8.94174 2.0498 7.95007 3.04147 7.95007Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99988 6.46252V7.95002"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.99151 3.4875C8.99151 3.75051 8.88703 4.00274 8.70106 4.18871C8.51509 4.37469 8.26285 4.47917 7.99984 4.47917C7.73684 4.47917 7.4846 4.37469 7.29863 4.18871C7.11266 4.00274 7.00818 3.75051 7.00818 3.4875C7.00818 2.93878 7.99984 2 7.99984 2C7.99984 2 8.99151 2.93878 8.99151 3.4875Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9664 6.46252V7.95002"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9581 3.4875C12.9581 3.75051 12.8536 4.00274 12.6676 4.18871C12.4816 4.37469 12.2294 4.47917 11.9664 4.47917C11.7034 4.47917 11.4512 4.37469 11.2652 4.18871C11.0792 4.00274 10.9747 3.75051 10.9747 3.4875C10.9747 2.93878 11.9664 2 11.9664 2C11.9664 2 12.9581 2.93878 12.9581 3.4875Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.03308 6.46252V7.95002"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.02484 3.4875C5.02484 3.75051 4.92036 4.00274 4.73438 4.18871C4.54841 4.37469 4.29618 4.47917 4.03317 4.47917C3.77016 4.47917 3.51793 4.37469 3.33196 4.18871C3.14598 4.00274 3.0415 3.75051 3.0415 3.4875C3.0415 2.93878 4.03317 2 4.03317 2C4.03317 2 5.02484 2.93878 5.02484 3.4875Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.0498 10.9052C2.20214 11.1643 2.41953 11.3791 2.68043 11.5284C2.94134 11.6777 3.23672 11.7562 3.5373 11.7562C3.83789 11.7562 4.13327 11.6777 4.39418 11.5284C4.65508 11.3791 4.87247 11.1643 5.0248 10.9052C5.17714 11.1643 5.39453 11.3791 5.65543 11.5284C5.91634 11.6777 6.21172 11.7562 6.5123 11.7562C6.81289 11.7562 7.10827 11.6777 7.36918 11.5284C7.63008 11.3791 7.84747 11.1643 7.9998 10.9052C8.15214 11.1643 8.36953 11.3791 8.63043 11.5284C8.89134 11.6777 9.18672 11.7562 9.4873 11.7562C9.78789 11.7562 10.0833 11.6777 10.3442 11.5284C10.6051 11.3791 10.8225 11.1643 10.9748 10.9052C11.1271 11.1643 11.3445 11.3791 11.6054 11.5284C11.8663 11.6777 12.1617 11.7562 12.4623 11.7562C12.7629 11.7562 13.0583 11.6777 13.3192 11.5284C13.5801 11.3791 13.7975 11.1643 13.9498 10.9052"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

export default CakeIcon;
